<template>
<div id="signup" class="signup">
  <section class="container">
    <div class="row">
      <div class="form-title">{{ $t('signup.signup.title') }}</div>
    </div>
    <div class="row">
      <div class="register-step">
        <div class="step-item step1 on">Account information</div>
        <div class="step-item step2 on">Confirmation</div>
        <div class="step-item step3 on">Payment</div>
        <div class="step-item step4 on">Complate</div>
      </div>
      <div class="register-step-bg step4"></div>
    </div>
    <div class="row">
      <div class="text-center">{{ $t('signup.signup.payment_finished') }}</div>
    </div>
    <div class="row">
      <button type="button" class="button button-primary next" @click="next">
        <span>{{ $t('common.button.next') }}</span>
      </button>
     </div>
  </section>
</div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import {api} from "../../config";

  export default {
    components: {
    },
    data() {
      return {
      };
    },
    mounted() {
      
    },
    computed: {
      ...mapGetters([
        'selectedLanguage'
      ])
    },
    methods: {
      next(){
        let self = this;
        self.$store.dispatch('showLoading', true)
        
        axios.get(api.section)
        .then(function(resp) {
          let keyList = Object.keys(resp.data.section)
          
          axios.get(api.lessons, {
            params: {
              section_id: resp.data.section[keyList[0]].section_id,
              section_status: 'all'
            }
          })
          .then((resp) => {
            self.$store.dispatch('setLessons',  resp.data)
            self.$store.dispatch('showLoading', false)
            self.$router.push({name: 'apps'})
          
          });
          
        });
      
      
      }
    }
  }
</script>
